import { FeatureFlags, Permission } from '../enums/generated.enums';
import { ModuleType, PageType, SubPageType } from '../enums/page-type.enum';

export class PermissionHelper {
  static get userPermissions(): Permission[] {
    return Object.keys(Permission) as Permission[];
  }

  static get organizationPermissions(): Permission[] {
    return [
      Permission.Monitoring,
      Permission.Orchestration,
      Permission.OrchestrationSettings,
      Permission.Simulator,
      Permission.SimulatorSettings,
      Permission.Analytics,
      Permission.AnalyticsSettings,
      Permission.RuntimeAnalysis,
      Permission.Reporting,
      Permission.ReportingSettings,
      Permission.Benchmarking,
      Permission.BenchmarkingSettings,
      Permission.MetricAlerts,
      Permission.IncidentDetection,
      Permission.FastAnomalyDetection,
      Permission.AiAgent,
    ];
  }

  static get apiKeyPermissions(): Permission[] {
    return [
      Permission.Import,
      Permission.OrchestrationWebhooks,
      Permission.UiPathWebhooks,
    ];
  }

  static getPagePermissions(module: ModuleType, page: PageType, subPage?: SubPageType): Permission[] {
    switch (module) {
      case ModuleType.Monitoring:
        return [Permission.Monitoring];
      case ModuleType.Orchestration:
        switch (page) {
          case PageType.Simulator:
            return [Permission.Simulator];
          case PageType.AuditLog:
            return [Permission.Orchestration, Permission.OrganizationSettings];
          default:
            return [Permission.Orchestration];
        }
      case ModuleType.Analytics:
        switch (page) {
          case PageType.RuntimeAnalysis:
            return [Permission.RuntimeAnalysis];
          case PageType.Anomalies:
            return [Permission.FastAnomalyDetection];
          default:
            return [Permission.Analytics];
        }
      case ModuleType.Reporting:
        switch (page) {
          case PageType.ProcessReporting:
            return [Permission.ProcessReporting];
          case PageType.ExecutiveOverview:
          case PageType.MonthlyReports:
            return [Permission.Reporting];
          case PageType.BenchmarkOverview:
            return [Permission.Benchmarking];
          default:
            return [Permission.Reporting];
        }
      case ModuleType.Workflows: {
        return [Permission.Monitoring];
      }
      case ModuleType.Settings: {
        switch (subPage) {
          case SubPageType.GeneralSettings:
          case SubPageType.ProcessesSettings:
          case SubPageType.ResourcesSettings:
          case SubPageType.QueuesSettings:
          case SubPageType.UsersSettings:
          case SubPageType.TenantsSettings:
          case SubPageType.ApiCredentialsSettings:
            return [Permission.OrganizationSettings];
          case SubPageType.AnomaliesSettings:
            return [Permission.FastAnomalyDetection];
          case SubPageType.NotificationsSettings:
            return [Permission.OrchestrationSettings, Permission.AnalyticsSettings, Permission.MetricAlerts];
          case SubPageType.ExternalServicesSettings:
          case SubPageType.ConditionStates:
          case SubPageType.PendingSessions:
          case SubPageType.OrchestrationDebugging:
            return [Permission.OrchestrationSettings];
          case SubPageType.ReportingSettings:
          case SubPageType.BillingGroupsSettings:
            return [Permission.ReportingSettings];
          case SubPageType.BusinessProcessesSettings:
          case SubPageType.SavingsSettings:
          case SubPageType.GroupsSettings:
          case SubPageType.ImportExportSettings:
            return [Permission.ReportingSettings, Permission.AnalyticsSettings, Permission.BenchmarkingSettings];
          case SubPageType.BenchmarkingSettings:
            return [Permission.BenchmarkingSettings];
          default:
            return [Permission.OrganizationSettings];
        }
      }
      case ModuleType.Admin:
        return [Permission.SystemAdmin];
      default:
        return null;
    }
  }

  static getPageFeatureFlag(module: ModuleType, page: PageType, subPage?: SubPageType): FeatureFlags {
    if (module === ModuleType.Workflows) {
      return FeatureFlags.Workflows;
    }
    if (subPage === SubPageType.DumpViewer) {
      return FeatureFlags.DumpViewer;
    }
    if (subPage === SubPageType.MsTeamsSettings) {
      return FeatureFlags.MsTeamsIntegration;
    }

    return null;
  }
}
